export function SetKauLoginParameters(dropdownList: any) {
    const target: HTMLSelectElement = event.target as HTMLSelectElement;

    const userGuid: string = target.dataset.userGuid;

    localStorage.setItem(`selected-index-${userGuid}`, target.selectedIndex.toString());
}

$(() => {
    const dropdowns = $('.kau-dropdown');

    dropdowns.each(function () {
        const userGuid: string = this.dataset.userGuid;

        const selectedIndexString: string = window.localStorage.getItem(`selected-index-${userGuid}`);
        if (selectedIndexString) {
            const selectedIndex: number = parseInt(selectedIndexString);

            (this as HTMLSelectElement).selectedIndex = selectedIndex;
        }
    });
});
